<template>
  <div :class="[backgroundClass, 'd-flex', 'flex-column', 'justify-space-between', 'white--text']">
    <div class="d-flex align-start justify-center">
      <div class="content d-flex flex-row align-center justify-center flex-wrap">
        <Robin animation="eating" :width="140" :height="140" :loop="true" :show-text="false" />
        <div
          class="text mt-4 mx-auto white--text"
          :class="{ 'text-left': !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm }"
        >
          <span>Loading, please wait</span>
          <br />
          <v-slide-y-transition>
            <span v-show="show">This should only take a few seconds.</span>
          </v-slide-y-transition>
        </div>
      </div>
    </div>
    <AppDebugBanner show-wl-ready />
  </div>
</template>

<script>
import Robin from "@/components/Robin.vue";
import AppDebugBanner from "@/components/app/AppDebugBanner.vue";
import loadingScreenBackgroundMixin from "@/mixins/loadingScreenBackground";

export default {
  /**
   * App.vue unmounts every page component while the whitelabel gate is closed,
   * so this screen is the only titled component mounted during that window —
   * titleMixin turns any declared title into "Loading..." until the config
   * settles (ADO #187152).
   */
  title: "Loading",
  components: {
    Robin,
    AppDebugBanner,
  },
  mixins: [loadingScreenBackgroundMixin],
  props: {
    show: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.background-lightened {
  background-color: var(--v-systemPrimary-base);
  background-image: radial-gradient(
      ellipse 110% 85% at 32% 80%,
      rgba(166, 34, 122, 0.34) 0%,
      transparent 55%
    ),
    radial-gradient(ellipse 160% 95% at 50% 0%, #166690 0%, transparent 70%);
  background-attachment: fixed;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.text {
  color: grey;
  font-size: medium;
  min-width: 300px;
}
.content {
  margin-top: 15vh;
}

@media (max-width: 2000px) {
  .text {
    font-size: large;
  }
}
@media (min-width: 2001px) {
  .text {
    font-size: x-large;
  }
}
</style>
